package della8.core.support

import techla.reservation.Availability

fun List<Availability>.getOrNull(dayOfWeek: kotlinx.datetime.DayOfWeek) =
    firstOrNull { it.date.dateTime.dayOfWeek == dayOfWeek }
